<div [class]="'s__text-block s__text-block--' + layout()">
  @if (layout() === 'split-right' && mediaSrc()) {
    <div class="s__text-block__media">
      <img
        [ngSrc]="mediaSrc()"
        [width]="mediaWidth() || 800"
        [height]="mediaHeight() || 600"
        [alt]="mediaAlt()"
        sizes="(min-width: 1024px) 50vw, 100vw"
        class="s__text-block__media-img"
      />
    </div>
  }
  <div class="s__text-block__content s__prose">
    @if (layout() === 'prose' && mediaSrc()) {
      <img
        [ngSrc]="mediaSrc()"
        [width]="mediaWidth() || 800"
        [height]="mediaHeight() || 600"
        [alt]="mediaAlt()"
        sizes="100vw"
        class="s__text-block__media-img"
      />
    }
    @if (body()) {
      <div [innerHTML]="trustedBody()"></div>
    }
    <ng-content />
  </div>
  @if (layout() === 'split-left' && mediaSrc()) {
    <div class="s__text-block__media">
      <img
        [ngSrc]="mediaSrc()"
        [width]="mediaWidth() || 800"
        [height]="mediaHeight() || 600"
        [alt]="mediaAlt()"
        sizes="(min-width: 1024px) 50vw, 100vw"
        class="s__text-block__media-img"
      />
    </div>
  }
</div>
